import React from 'react';
import 'react-virtualized/styles.css';
// This component is never renderer and its purpose is only to "deliver props" to the actual
// Virtualized Column component which is generated in our Table wrapper.
// Reason: React Virtualized Column component has several props that are optional and fallback to some default values provided by the library.
// In order to overwrite default values we need to know which props were undefined in the moment of instantiation.
export function TableColumn(props) {
    return React.createElement("div", Object.assign({}, props));
}
